
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import SelectCreate from "components/Varios/SelectCreate.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardDireccionTesis from "components/Varios/CardDireccionTesis.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';

const API_URL = configData.SERVER_URL

export class DireccionTesisData {
    idproyectoinvestigacion: number = 0;
    idpersona: number = 0;
    idpais: number = 0;
    idinstitucion: number = 0;

    tipo: string = "";
    subtipo: number = 0;

    titulotesis: string = "";
    institucion: string = "";

    estudiante: string = "";
    anio: number = 0;
    estaenproceso: string = "";

    estado: string = "A";
    nombre: string = "a";

    idnomenclaturatit: number = 0;
    idareaconocim: number = 0;
    idsubareaconoc: number = 0;

    idareafrascati: number = 0;
    idsubareafrascati: number = 0;

    strCampoamplio?: string = "";
    strCampodetallado?: string = "";
    strCampoespecifico?: string = "";

    idnomenclaturatit2: number = 0;
    idareaconocim2: number = 0;
    idsubareaconoc2: number = 0;

    idareafrascati2: number = 0;
    idsubareafrascati2: number = 0;

    strCampoamplio2?: string = "";
    strCampodetallado2?: string = "";
    strCampoespecifico2?: string = "";

    refarchivo1: string = "";
    refarchivo2: string = "";
    refarchivo3: string = "";

    strTipo: string = "";
    strSubtipo: string = "";
    strPais: string = "";
}


interface DireccionTesisDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: DireccionTesisData;
    paisList: Array<any>;
    tipoProyectoList: Array<any>;
    subtipoProyectoList: Array<any>;
    areaCINEList: Array<any>;
    subAreaCINEList: Array<any>;
    materiaCINEList: Array<any>;
    areaFrascatiList: Array<any>;
    subAreaFrascatiList: Array<any>;

    areaCINEList2: Array<any>;
    subAreaCINEList2: Array<any>;
    materiaCINEList2: Array<any>;
    areaFrascatiList2: Array<any>;
    subAreaFrascatiList2: Array<any>;

    DireccionTesisDataList: DireccionTesisData[];
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class DireccionTesis extends React.Component<RouteComponentProps<{}>, DireccionTesisDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new DireccionTesisData(),
            tipoProyectoList: [], subtipoProyectoList: [], areaCINEList: [], subAreaCINEList: [], materiaCINEList: [],
            areaFrascatiList: [], subAreaFrascatiList: [], areaCINEList2: [], subAreaCINEList2: [], materiaCINEList2: [],
            areaFrascatiList2: [], subAreaFrascatiList2: [], DireccionTesisDataList: [], paisList: [], error: null,
            tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarDireccionTesis = this.cargarDireccionTesis.bind(this);
        this.cargarSubtipos = this.cargarSubtipos.bind(this);
        this.cargarSubAreaCINE = this.cargarSubAreaCINE.bind(this);
        this.cargarMaterias = this.cargarMaterias.bind(this);
        this.cargarSubAreaFrascati = this.cargarSubAreaFrascati.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarDireccionTesis();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosEscalafon/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPOS DE PROYECTO
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/TIPO DIRECCION TESIS")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoProyectoList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        tipoProyectoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )


        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/NIVEL TESIS")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            subtipoProyectoList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        subtipoProyectoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS DE CONOCMIENTO CINE
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoAmplio/0/0/0/00")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        this.setState({
                            areaCINEList: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                            areaCINEList2: result.entTabla.map(d => ({
                                "value": d.campoamplio,
                                "label": d.nombrecampoa
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener las áreas de conocimiento CINE.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        areaCINEList: [],
                        areaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER AREAS FRASCATI
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/" + "AREA FRASCATI")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            areaFrascatiList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                            areaFrascatiList2: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener las áreas FRASCATI.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        areaFrascatiList: [],
                        areaFrascatiList2: [],
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER PROYECTOS DE PERSONA
    cargarDireccionTesis() {
        fetch(API_URL + "DatosEscalafon/TesisDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            DireccionTesisDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener los DireccionTesis.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        DireccionTesisDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }


    //API PARA OBTENER SUBTITPOS
    cargarSubtipos(subtipo) {
        
    }

    cargarSubAreaFrascati(idcatalogopadre, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["idareafrascati" + tipo] = idcatalogopadre;
        if (change) {
            dto['idsubareafrascati' + tipo] = 0;
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogoSubAreaFrascatiByCodigo/" + idcatalogopadre)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (tipo == "") {
                            this.setState({
                                subAreaFrascatiList: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        }
                        else {
                            this.setState({
                                subAreaFrascatiList2: result.entTabla.map(d => ({
                                    "value": d.codigo,
                                    "label": d.descripcion
                                })),
                            });
                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener las subáreas FRASCATI.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        subAreaFrascatiList: [],
                        subAreaFrascatiList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarSubAreaCINE(strCampoamplio, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["strCampoamplio" + tipo] = strCampoamplio;
        if (change) {
            dto['strCampoespecifico' + tipo] = "";
            dto['strCampodetallado' + tipo] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoEspecifico/0/0/00/" + strCampoamplio)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (tipo === "") {
                            this.setState({
                                subAreaCINEList: result.entTabla.map(d => ({
                                    "value": d.campoespecifico,
                                    "label": d.nombrecampoe
                                })),
                            });
                        }
                        else {
                            this.setState({
                                subAreaCINEList2: result.entTabla.map(d => ({
                                    "value": d.campoespecifico,
                                    "label": d.nombrecampoe
                                })),
                            });
                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener las subáreas CINE.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        subAreaCINEList: [],
                        subAreaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarMaterias(strCampoespecifico, change = true, tipo) {
        var dto = this.state.dtoData;
        dto["strCampoespecifico" + tipo] = strCampoespecifico;
        if (change) {
            dto['strCampodetallado' + tipo] = "";
        }

        this.setState({ dtoData: dto });

        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCampoDetallado/0/00/" + dto['strCampoamplio' + tipo] + "/" + strCampoespecifico)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (tipo === "") {
                            this.setState({
                                materiaCINEList: result.entTabla.map(d => ({
                                    "value": d.idnomenclaturatit,
                                    "label": d.nombrecampod
                                })),
                            });
                        }
                        else {
                            this.setState({
                                materiaCINEList2: result.entTabla.map(d => ({
                                    "value": d.idnomenclaturatit,
                                    "label": d.nombrecampod
                                })),
                            });
                        }

                    } else {
                        alertService.error("Ocurrió un error al obtener las materias CINE.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        materiaCINEList: [],
                        materiaCINEList2: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }



    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "anio") {
            value = String(value)
            var info = value.split('/').reverse().join('-');
            var date = new Date(String(info))
            dto["anio"] = date.getFullYear();
        }

        if (name === "idnomenclaturatit") {
            dto["strCampodetallado"] = value;
        }

        if (name === "idnomenclaturatit2") {
            dto["strCampodetallado2"] = value;
        }

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
            //tiposEvidencia: this.cargarEvidencias(fileInfoState)
        });

    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "TE1", "label": "Evidencia de Dirección de Tesis" + filesData.filter(f => f.type == "TE1").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "TE2", "label": "Evidencia de Dirección de Tesis 2" + filesData.filter(f => f.type == "TE2").map(ff => ': ' + ff.file.name).join(', ') },
            { "value": "TE3", "label": "Evidencia de Dirección de Tesis 3" + filesData.filter(f => f.type == "TE3").map(ff => ': ' + ff.file.name).join(', ') }
        ];
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: DireccionTesisData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo1) {
            evidencias.push({ name: "TE1-" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoTesis/1/" + infoAcademica.idproyectoinvestigacion });
        }
        if (infoAcademica.refarchivo2) {
            evidencias.push({ name: "TE2-" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoTesis/2/" + infoAcademica.idproyectoinvestigacion });
        }
        if (infoAcademica.refarchivo3) {
            evidencias.push({ name: "TE3-" + this.state.currentUser.identificacion + ".PDF", url: API_URL + "DatosEscalafon/RefarchivoTesis/3/" + infoAcademica.idproyectoinvestigacion });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new DireccionTesisData() });
    }

    onClickEdit(idpersona) {
        this.setState({
            dtoData: new DireccionTesisData()
        });

        fetch(API_URL + "DatosEscalafon/TesisById/" + idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        if (result.entTabla[0]["strCampoamplio"]) {
                            this.cargarSubAreaCINE(result.entTabla[0]["strCampoamplio"], false, "")
                        }

                        if (result.entTabla[0]["strCampoespecifico"]) {
                            this.cargarMaterias(result.entTabla[0]["strCampoespecifico"], false, "")
                        }

                        if (result.entTabla[0]["idareafrascati"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati"], false, "")
                        }

                        if (result.entTabla[0]["strCampoamplio2"]) {
                            this.cargarSubAreaCINE(result.entTabla[0]["strCampoamplio2"], false, "2")
                        }

                        if (result.entTabla[0]["strCampoespecifico2"]) {
                            this.cargarMaterias(result.entTabla[0]["strCampoespecifico2"], false, "2")
                        }

                        if (result.entTabla[0]["idareafrascati2"]) {
                            this.cargarSubAreaFrascati(result.entTabla[0]["idareafrascati2"], false, "2")
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new DireccionTesisData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idproyectoinvestigacion) {
        fetch(API_URL + "FormularioController/DeleteDatosTesis/" + idproyectoinvestigacion, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El idioma se eliminó correctamente.")
                        this.cargarDireccionTesis();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        if (filesData.length > 0) {
            var formFilesData = new FormData();

            filesData.map((fileData) => {
                formFilesData.append(fileData.type, fileData.file, fileData.file.name);
            });

            formFilesData.append('idproyectoinvestigacion', identidad);
            fetch(API_URL + postFilesUrl, {
                method: 'POST',
                body: formFilesData
            })
                .then(response => response.json())
                .then(
                    (responseJson) => {
                        if (responseJson["strEstado"] === "N") {
                            alertService.error("Ocurrió un error al guardar las evidencias.")
                        }
                        else if (responseJson["strEstado"] === "S") {
                            this.cargarDireccionTesis();
                            alertService.success("Las evidencias se cargaron exitosamente");
                        }
                    },
                    (error) => { alertService.error("Ocurrió un error al cargar las evidencias.") }
                );
        }
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });

        dto.idpersona = this.state.currentUser.idpersona;

        if (formIsValid) {
            delete dto['strCampoamplio'];
            delete dto['strCampoespecifico'];
            delete dto['strCampodetallado'];
            delete dto['strCampoamplio2'];
            delete dto['strCampoespecifico2'];
            delete dto['strCampodetallado2'];
        }

        const data = JSON.stringify({
            "entidad": dto,
        });
        
        if (formIsValid) {
            if (dto.idproyectoinvestigacion === 0) {
                fetch(API_URL + "FormularioController/PostDatosTesis", {

                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La dirección de tesis se ha registrado correctamente.")
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                                this.postFiles("FormularioController/PostFilesDatosEscalafon/DireccionTesis", filesData, responseJson.entidad.idproyectoinvestigacion);
                                this.cargarDireccionTesis();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosTesis", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])

                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("La dirección de tesis se ha actualizado correctamente.");
                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                                this.postFiles("FormularioController/PostFilesDatosEscalafon/DireccionTesis", filesData, responseJson.entidad.idproyectoinvestigacion);
                                this.onClickLimpiar();
                                this.cargarDireccionTesis();

                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )


            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading || !this.state.currentUser.roles.includes("DOCENTEGRADO,")

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.DireccionTesisDataList, this.state.paisList, this.state.tipoProyectoList,
                this.state.subtipoProyectoList, this.state.areaCINEList, this.state.subAreaCINEList,
                this.state.materiaCINEList, this.state.areaFrascatiList, this.state.subAreaFrascatiList, this.state.areaCINEList,
                this.state.subAreaCINEList2, this.state.materiaCINEList2, this.state.areaFrascatiList2, this.state.subAreaFrascatiList2,
                this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(DireccionTesisDataList: Array<any>, paisList: Array<any>, tipoProyectoList: Array<any>,
        subtipoProyectoList: Array<any>, areaCINEList: Array<any>, subAreaCINEList: Array<any>,
        materiaCINEList: Array<any>, areaFrascatiList: Array<any>, subAreaFrascatiList: Array<any>, areaCINEList2: Array<any>,
        subAreaCINEList2: Array<any>, materiaCINEList2: Array<any>, areaFrascatiList2: Array<any>, subAreaFrascatiList2: Array<any>,
        tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Dirección de tesis</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipo">Tipo de proyecto*</Label>
                                                    <SelectItem
                                                        options={tipoProyectoList}
                                                        value={this.state.dtoData.tipo}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipo"
                                                        id="tipo"
                                                        icon="fa-caret-right"
                                                        
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="subtipo">Nivel*</Label>
                                                    <SelectItem
                                                        options={subtipoProyectoList}
                                                        value={this.state.dtoData.subtipo}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="subtipo"
                                                        id="subtipo"
                                                        icon="fa-caret-right"
                                                        
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label for="nomtitulotesisbre">Título tesis*</Label>
                                                    <Input maxLength="500" name="titulotesis" id="titulotesis" value={this.state.dtoData.titulotesis} onChange={this.handleChange} required  />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <Label for="anio">Año*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.anio ? new Date(this.state.dtoData.anio, 0, 1) : 0}
                                                    name="anio"
                                                    id="anio"
                                                    onChange={this.handleSelectChange}
                                                    dateFormat="yyyy"

                                                />
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="idpais">País*</Label>
                                                    <SelectItem
                                                        options={paisList}
                                                        value={this.state.dtoData.idpais}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idpais"
                                                        id="idpais"
                                                        icon="pais"
                                                        
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="institucion">Institución*</Label>
                                                    <Input maxLength="300" name="institucion" id="institucion" value={this.state.dtoData.institucion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label for="estudiante">Estudiante(s)*</Label>
                                                    <Input maxLength="100" name="estudiante" id="estudiante" value={this.state.dtoData.estudiante} onChange={this.handleChange} required  />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="estaenproceso">En proceso*</Label>
                                                    <Row>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-5 ml-1"
                                                                type="radio"
                                                                checked={this.state.dtoData.estaenproceso === "S"}
                                                                value="S"
                                                                id="estaenproceso"
                                                                name="estaenproceso"
                                                                onChange={this.handleChange}
                                                                label="Sí"
                                                                
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="N"
                                                                id="estaenproceso2"
                                                                name="estaenproceso"
                                                                checked={this.state.dtoData.estaenproceso === "N"}
                                                                onChange={this.handleChange}
                                                                label="No"
                                                                
                                                            />
                                                        </Col>
                                                    </Row>

                                                </FormGroup>
                                            </Col>
                                            
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia certificado</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="TE1"
                                                            placeholder={this.state.dtoData.refarchivo1 ? "Actualizar Evidencia de Dirección de Tesis 1" : "Subir Evidencia de Dirección de Tesis 1"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 1"
                                                        id="downloadRef1"
                                                        refarchivo={this.state.dtoData.refarchivo1}
                                                        name={"TE1-" + this.state.currentUser.identificacion + ".PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoTesis/1/" + this.state.dtoData.idproyectoinvestigacion}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia tesis</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="TE2"
                                                            placeholder={this.state.dtoData.refarchivo2 ? "Actualizar Evidencia de Dirección de Tesis 2" : "Subir Evidencia de Dirección de Tesis 2"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 2"
                                                        id="downloadRef2"
                                                        refarchivo={this.state.dtoData.refarchivo2}
                                                        name={"TE2-" + this.state.currentUser.identificacion + ".PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoTesis/2/" + this.state.dtoData.idproyectoinvestigacion}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <Label for="fechagraduacion">Evidencia</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="TE3"
                                                            placeholder={this.state.dtoData.refarchivo3 ? "Actualizar Evidencia de Dirección de Tesis 3" : "Subir Evidencia de Dirección de Tesis 3"} />
                                                    </Col>
                                                    <InputFileDownload tipo="evidencia 3"
                                                        id="downloadRef3"
                                                        refarchivo={this.state.dtoData.refarchivo3}
                                                        name={"TE3-" + this.state.currentUser.identificacion + ".PDF"}
                                                        url={API_URL + "DatosEscalafon/RefarchivoTesis/3/" + this.state.dtoData.idproyectoinvestigacion}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO CINE</p>
                                                <FormGroup row>
                                                    <Col md={4} className="">
                                                        <Label for="idpais">Área de conocimiento <br /> CINE en función del título*</Label>
                                                        <SelectItem
                                                            options={areaCINEList}
                                                            value={this.state.dtoData.strCampoamplio}
                                                            onChange={this.cargarSubAreaCINE}
                                                            placeholder=""
                                                            name="strCampoamplio"
                                                            id="strCampoamplio"
                                                            icon="fa-caret-right"
                                                            tipo=""
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampoespecifico">Sub-Área de  <br /> conocimiento CINE*</Label>
                                                        <SelectItem
                                                            options={subAreaCINEList}
                                                            value={this.state.dtoData.strCampoespecifico}
                                                            onChange={this.cargarMaterias}
                                                            placeholder=""
                                                            name="strCampoespecifico"
                                                            id="strCampoespecifico"
                                                            icon="fa-caret-right"
                                                            tipo=""
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampodetallado">Área de conocimiento <br /> (materias)*</Label>
                                                        <SelectItem
                                                            options={materiaCINEList}
                                                            value={this.state.dtoData.idnomenclaturatit}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idnomenclaturatit"
                                                            id="strCampodetallado"
                                                            icon="fa-caret-right"
                                                            tipo=""
                                                            
                                                        />
                                                    </Col>
                                                </FormGroup>

                                            </Col>

                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>ÁREA DE CONOCIMIENTO FRASCATI</p>
                                                <FormGroup row>
                                                    <Col md={6} className="">
                                                        <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título*</Label>
                                                        <SelectItem
                                                            options={areaFrascatiList}
                                                            value={this.state.dtoData.idareafrascati}
                                                            onChange={this.cargarSubAreaFrascati}
                                                            placeholder=""
                                                            name="idareafrascati"
                                                            id="idareafrascati"
                                                            icon="fa-caret-right"
                                                            tipo=""
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={6} className="">
                                                        <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI*</Label>
                                                        <SelectItem
                                                            options={subAreaFrascatiList}
                                                            value={this.state.dtoData.idsubareafrascati}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idsubareafrascati"
                                                            id="idsubareafrascati"
                                                            icon="fa-caret-right"
                                                            tipo=""
                                                            
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>


                                        </Row>
                                        <Row form>
                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>2DA ÁREA DE CONOCIMIENTO CINE</p>
                                                <FormGroup row>
                                                    <Col md={4} className="">
                                                        <Label for="idpais">Área de conocimiento <br /> CINE en función del título*</Label>
                                                        <SelectItem
                                                            options={areaCINEList2}
                                                            value={this.state.dtoData.strCampoamplio2}
                                                            onChange={this.cargarSubAreaCINE}
                                                            placeholder=""
                                                            name="strCampoamplio2"
                                                            id="strCampoamplio2"
                                                            icon="fa-caret-right"
                                                            tipo="2"
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampoespecifico">Sub-Área de  <br /> conocimiento CINE*</Label>
                                                        <SelectItem
                                                            options={subAreaCINEList2}
                                                            value={this.state.dtoData.strCampoespecifico2}
                                                            onChange={this.cargarMaterias}
                                                            placeholder=""
                                                            name="strCampoespecifico2"
                                                            id="strCampoespecifico2"
                                                            icon="fa-caret-right"
                                                            tipo="2"
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={4} className="">
                                                        <Label for="strCampodetallado">Área de conocimiento <br /> (materias)*</Label>
                                                        <SelectItem
                                                            options={materiaCINEList2}
                                                            value={this.state.dtoData.idnomenclaturatit2}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idnomenclaturatit2"
                                                            id="strCampodetallado2"
                                                            icon="fa-caret-right"
                                                            tipo="2"
                                                            
                                                        />
                                                    </Col>
                                                </FormGroup>

                                            </Col>

                                            <Col md={6}>
                                                <p style={{ color: "#FFC200" }}>2DA ÁREA DE CONOCIMIENTO FRASCATI</p>
                                                <FormGroup row>
                                                    <Col md={6} className="">
                                                        <Label for="idpais">Área de conocimiento FRASCATI  <br /> en función del título*</Label>
                                                        <SelectItem
                                                            options={areaFrascatiList2}
                                                            value={this.state.dtoData.idareafrascati2}
                                                            onChange={this.cargarSubAreaFrascati}
                                                            placeholder=""
                                                            name="idareafrascati2"
                                                            id="idareafrascati2"
                                                            icon="fa-caret-right"
                                                            tipo="2"
                                                            
                                                        />
                                                    </Col>
                                                    <Col md={6} className="">
                                                        <Label for="idsubareafrascati">Sub-Área de conocimiento  <br /> FRASCATI*</Label>
                                                        <SelectItem
                                                            options={subAreaFrascatiList2}
                                                            value={this.state.dtoData.idsubareafrascati2}
                                                            onChange={this.handleSelectChange}
                                                            placeholder=""
                                                            name="idsubareafrascati2"
                                                            id="idsubareafrascati2"
                                                            icon="fa-caret-right"
                                                            tipo="2"
                                                            
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>


                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {DireccionTesisDataList.map((dto, index) =>
                                                <CardDireccionTesis
                                                    key={dto.idproyectoinvestigacion}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + DireccionTesisDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idproyectoinvestigacion)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default DireccionTesis;